import React from 'react';

const Spinner: React.FC = () => {
    return (
        <div className="w-7 h-7 border-t-2 border-blue-500 border-solid rounded-full animate-spin"></div>
    );
};

export default Spinner;
